import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import athenahealthLogo from "../assets/logo-athenahealth.svg";
import patientLogo from "../assets/logo-patient.png";
import config from "../lib/config";
import { isPatientUser } from "../lib/token-utils";

export interface BaseContainerProps {
  childElement: React.JSX.Element;
}

const AthenaLogo = (): React.JSX.Element => {
  const authState = useOktaAuth()?.authState ?? null;
  const showPatientLogo =
    config.unifiedPatientLoginEnabled && isPatientUser(authState);
  const logoAlt = showPatientLogo
    ? "athenaPatient logo"
    : "Athenahealth Inc. logo";

  return (
    <div
      className={`okta-sign-in-header auth-header${showPatientLogo ? " patient-header" : ""}`}
      style={{ border: "none" }}
    >
      <h1>
        <img
          src={showPatientLogo ? patientLogo : athenahealthLogo}
          className="auth-org-logo"
          alt={logoAlt}
          aria-label={logoAlt}
        />
      </h1>
      <div
        data-type="beacon-container"
        className="beacon-container"
        style={{ transform: "scale(0, 0)", textIndent: "0px" }}
      ></div>
    </div>
  );
};

const BaseContainer = ({
  childElement,
}: BaseContainerProps): React.JSX.Element => {
  return (
    <div id="layout">
      <div id="main-container">
        <div id="inner-container">
          <div id="okta-login-container" style={{ marginTop: "0px" }}>
            <main
              data-se="auth-container"
              id="okta-sign-in"
              className="auth-container main-container no-beacon rounded-border"
            >
              <AthenaLogo />
              <div className="header-divider okta-form-divider form-divider"></div>
              <div className="auth-content">
                <div className="auth-content-inner">{childElement}</div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseContainer;
